import { combineReducers } from 'redux';
import parameterReducer from './parameter/parameterReducer';
import therapeuticCategoryReducer from './therapeuticCategory/therapeuticCategoryReducer';
import therapeuticAreaReducer from './therapeuticArea/therapeuticAreaReducer';
import loginReducer from './login/loginReducer';
import loaderReducer from './loader/loaderReducer';

const appReducer = combineReducers({
  parameter: parameterReducer,
  therapeuticCategory: therapeuticCategoryReducer,
  therapeuticArea: therapeuticAreaReducer,
  user: loginReducer,
  loader: loaderReducer,
});

export default appReducer;



// WEBPACK FOOTER //
// ./src/reducers.js